import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  Renderer2,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NgClass } from '@angular/common';

@Component({
    selector: 'div[app-drawer]',
    imports: [MatIconModule, NgClass],
    templateUrl: './drawer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {}
})
export class DrawerComponent {
  private renderer = inject(Renderer2);

  @Input()
  public disabled: boolean = false;

  @Input()
  public isActive: boolean = false;

  @Output()
  public isActiveChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  toggle(e: MouseEvent | TouchEvent | KeyboardEvent) {
    e.stopPropagation();
    if (
      this.renderer.selectRootElement('body', true).getBoundingClientRect()
        .width < 768
    ) {
      if (!this.disabled) {
        this.isActive = !this.isActive;
        this.isActiveChange.emit(this.isActive);
        this.isActive
          ? this.renderer.setStyle(document.body, 'overflow', 'hidden')
          : this.renderer.setStyle(document.body, 'overflow', 'auto');
      }
    }
  }

  close(e: MouseEvent | TouchEvent | KeyboardEvent) {
    e.stopPropagation();
    if (this.isActive) {
      this.isActive = false;
      this.isActiveChange.emit(this.isActive);
      this.renderer.setStyle(document.body, 'overflow', 'auto');
    }
  }
}
